import React from "react";
import { motion } from "framer-motion";
import { IndianRupee, ClipboardCheck, Star } from "lucide-react";

function timeAgo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export default function CreatorActivityFeed({ analytics }) {
  const a = analytics || {};
  const activity = a.recent_activity || [];

  return (
    <div data-testid="creator-activity-feed">
      <h2 className="text-xl sm:text-2xl font-medium text-[#f7f8f8] mb-4">Latest Activities</h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 rounded-2xl border border-white/[0.08] bg-[#131a29]/80 backdrop-blur-xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.12)]">
          {activity.length === 0 ? (
            <p className="text-xs text-slate-500 text-center py-6" data-testid="activity-feed-empty">No student activity yet — share your course to get your first sale.</p>
          ) : (
            <div className="space-y-3.5">
              {activity.map((item, i) => (
                <motion.div key={i} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.04 }} className="flex items-start gap-3" data-testid={`activity-item-${i}`}>
                  <div className="w-7 h-7 rounded-lg bg-emerald-400/10 flex items-center justify-center shrink-0 mt-0.5">
                    <IndianRupee className="w-3.5 h-3.5 text-emerald-400" />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-slate-300">{item.text}</p>
                    <p className="text-[11px] text-slate-500">{timeAgo(item.at)}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>

        <div className="space-y-4">
          <div className="rounded-2xl border border-white/[0.08] bg-[#131a29]/80 backdrop-blur-xl p-5 shadow-[0_8px_32px_rgba(0,0,0,0.12)] flex items-center gap-3" data-testid="activity-pending-approvals">
            <div className="w-9 h-9 rounded-xl bg-amber-400/10 flex items-center justify-center shrink-0"><ClipboardCheck className="w-4.5 h-4.5 text-amber-400" /></div>
            <div>
              <p className="font-heading text-xl font-semibold text-[#f7f8f8]">{a.pending_approvals || 0}</p>
              <p className="text-[11px] text-[#8a8f98]">Pending Assignment Reviews</p>
            </div>
          </div>
          <div className="rounded-2xl border border-dashed border-white/[0.12] p-5 flex items-center gap-3" data-testid="activity-reviews-empty">
            <div className="w-9 h-9 rounded-xl bg-pink-400/10 flex items-center justify-center shrink-0"><Star className="w-4.5 h-4.5 text-pink-400" /></div>
            <div>
              <p className="text-xs text-slate-500">Reviews</p>
              <p className="text-[11px] text-slate-600">Awaiting Data</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
